<template  >


    <v-container v-if="style!==null" style="width:100%;height: calc(100% + 114px);max-width: 100%;margin: 0px 0px 0px;padding:0;overflow: visible !important;" :style="{'backgroundImage':'linear-gradient('+style.START_COLOR+','+ style.END_COLOR+')'}" >

        <div v-if="!in_bcf" style="background: url('/api/images/diagmonds.png') repeat;opacity: 0.15;z-index: 0; position: fixed; width: 100%;height: calc(100% + 114px);"></div>
      <v-img  v-else gradient="to top left, rgba(100,115,201,0), rgba(62, 62, 62, 0.14)" style="opacity: 1;z-index: 0; position: fixed; width: 100%;height: calc(100% + 114px);"
              height="300"    :src="require('../assets/soh_bg_small.jpg')" ></v-img>










        <v-img  :eager="true"  gradient="to top left, rgba(100,115,201,0), rgba(62, 62, 62, 0.14)" style="position:absolute;width:100%;top:-88px;height:300px;"
                height="300"   v-if="style.IMAGE!==null && style.IMAGE!==false && style.IMAGE!==0 && !in_bcf" :src="newImage!==null ? newImage : `/api/images/headers/${style.SID}.${style.IMAGE}`" ></v-img>

        <v-menu
                v-model="showImageMenu"
                absolute
                offset-y
                style="max-width: 600px;z-index: 1003;position: absolute;"
                v-if="edit_page"
        >
            <template v-slot:activator="{ on }">
                <div v-on="on">

                    <div  class="hover-darken" style="cursor:pointer;z-index:1000;position:absolute;width:100%;height:300px;top:-88px;"   ></div>
                </div>
            </template>

            <v-list >
                <v-list-item @click="updateHeaderImage">
                    <v-list-item-title><v-icon left>mdi-image-plus</v-icon>Byt bild</v-list-item-title>
                </v-list-item>
                <v-list-item @click="removeHeaderImage">
                    <v-list-item-title><v-icon left>delete</v-icon>Ta bort bild</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

                        <v-card

                                style="top:50px;text-align: center;height: 100px;"
                                class="mx-auto"
                                flat
                                dark
                                color="transparent"
                        >
                            <v-list-item style="z-index: 0;">
                                <v-list-item-avatar    size="80" class="mx-auto" color="grey">

                                    <v-img
                                            :elevation=20

                                            class=""
                                            v-if="streamer_image!==null"
                                            :src=streamer_image
                                    ></v-img>
                                </v-list-item-avatar>
                            </v-list-item>




                            <v-tabs hide-slider  :dark="style.SUGGESTION_TWO" class="mx-auto"  centered style="background:transparent !important;z-index: 1;position: relative;" v-model="tab">
                                <v-tab style="background:transparent !important;;z-index: 1000;position: relative;width:132px;">
                                    Donera
                                </v-tab>
                                <v-tab :class="tab===0? 'faded_img':''"  style="background:transparent !important;;z-index: 1000;position: relative;width:132px;">
                                    <v-img contain style="height:50px;" :src="require('../assets/stream_hotel_tiny.png')"></v-img>
                                </v-tab>
                            </v-tabs>
                        </v-card>




        <v-tabs-items style="background: transparent;min-height:1000px;" v-model="tab">
            <v-tab-item style="overflow: visible !important;min-height: 100%;">
        <v-row style="top:125px;position:relative;" align="center">
                    <v-col v-if="!in_bcf" :cols="$vuetify.breakpoint.mdAndUp? 3 : $vuetify.breakpoint.smAndDown? '0':'1'">
                        <DonationLeaderboard :isDark="style.SUGGESTION_TWO" v-if="style.SUGGESTION_THREE && tab===0" :local=true :key="renderIndex" class="hidden-md-and-down" style="max-width: 360px;  z-index: 2; height: 570px !important;" ></DonationLeaderboard>
                    </v-col>
                    <v-col v-else :cols="$vuetify.breakpoint.mdAndUp? 3 : $vuetify.breakpoint.smAndDown? '0':'1'">
                      <BCFLeaderboard :isDark="true"  :local=true :key="renderIndex" class="hidden-md-and-down" style="max-width: 360px;  z-index: 2; height: 570px !important;" ></BCFLeaderboard>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mdAndUp? 6 :  $vuetify.breakpoint.smAndDown? '12':'10'">
                        <v-card
                                class="mx-auto px-2"
                                max-width="544"
                                :dark="style.SUGGESTION_TWO || in_bcf"


                        >

                          <v-btn dark color="green" fab @click="edit_page=true" v-if="page_editable" style="position:absolute;top:-10px;right:-10px;z-index: 3;">
                            <v-icon large>mdi-pencil</v-icon>
                          </v-btn>
                          <v-img
                              height="70"
                              width="70"
                              eager
                              v-if="in_bcf"
                              style="position:absolute;right:10px;top:10px;"
                              :src="require('../assets/soh_logo.png')"
                          >

                          </v-img>





                            <v-card-text>
                                <v-list-item >

                                    <v-list-item-content>
                                        <v-list-item-title   v-if="(!edit_page)" class="display-1" style="text-align: center;" >{{in_bcf?'Skänk en gåva':style.TITLE}}</v-list-item-title>
                                        <v-list-item-title class="d-flex justify-center" v-if="edit_page" style="text-align: center;" >
                                            <input  v-autowidth="{maxWidth: '960px', minWidth: '20px', comfortZone: 20}"
                                                    class="display-1 centered_text"
                                                    style="max-height: 40px;text-align: center;z-index: 1000;background:rgba(231,216,158,0.19);"
                                                    v-model="style.TITLE"
                                                    :disabled="in_bcf"
                                            />

                                        </v-list-item-title>
                                        <v-list-item-subtitle  v-if="(!edit_page)" style="text-align: center;white-space: break-spaces;">{{in_bcf?'Tack för att du stöttar Barncancerfonden':style.DESC}}</v-list-item-subtitle>
                                        <v-list-item-subtitle style="text-align: center;" v-if="edit_page" >

                                            <input  v-autowidth="{maxWidth: '960px', minWidth: '20px', comfortZone: 20}"
                                                    style="font-size: 0.875rem;position: relative;text-align: center;z-index: 1005;background:rgba(231,216,158,0.19);"
                                                    :disabled="in_bcf"

                                                    class="centered_text"
                                                    v-model="style.DESC"
                                            />
                                        </v-list-item-subtitle>
                                    </v-list-item-content>


                                </v-list-item>
                                <v-form ref="payment_form" >


                                    <v-row style="height: 60px;">


                                        <v-col cols="6">
                                            <v-text-field
                                                    label="Avsändare"
                                                    outlined
                                                    dense
                                                    :rules="rules.name"
                                                    v-model="sender_name"
                                                    :disabled="need_setup"



                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="6">

                                            <v-combobox

                                                    v-model="amount_selected"
                                                    suffix="SEK"
                                                    dense
                                                    outlined
                                                    :items="style.suggestions"
                                                    type="number"
                                                    label="Summa"
                                                    class="hide_my_spin"
                                                    :rules="rules.amount"
                                                    :disabled="need_setup"

                                            >
                                                <template v-slot:item='{item}'> <v-chip small label  :color=colorChip(item) text-color="white" > <b>{{item}}</b></v-chip></template>
                                                <template v-slot:selection='{item}'> <v-chip small label  :color=colorChip(item) text-color="white" > <b>{{item}}</b></v-chip></template>


                                            </v-combobox>

                                        </v-col>

                                    </v-row>
                                    <v-row style="position: relative;height: 60px;">

                                        <v-col v-if="video_message_tab===1">
                                          <v-tabs
                                              dark
                                              next-icon="mdi-arrow-right-bold-box-outline"
                                              prev-icon="mdi-arrow-left-bold-box-outline"
                                              show-arrows
                                              v-model="video_selected"
                                              hide-slider

                                          >
                                            <v-tab
                                                style="display: none;"

                                            >
                                            </v-tab>

                                            <v-tab
                                                v-for="(video,index) in mediashare.examples"
                                                :key="index"

                                            >
                                              <v-img
                                                  :style="{'filter':`saturate(${video.link===youtube_link?1:0})`}"
                                                  style="height:50px;width:50px;border-radius:4px;"
                                                  :src="`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`"
                                              >

                                              </v-img>
                                            </v-tab>
                                          </v-tabs>
                                        </v-col>

                                        <v-col  v-else-if="!edit_page">
                                            <div class="text-center" style="white-space: nowrap;">


                                                <v-chip
                                                        small
                                                        class="ma-2"
                                                        v-for="amount in style.suggestions.slice()"
                                                        :key="amount"
                                                        link
                                                        label
                                                        :color=colorChip(amount)
                                                        style="color:white;"
                                                        @click="amount_selected=amount"


                                                >
                                                    <b>{{amount}}</b>
                                                </v-chip>


                                            </div>
                                        </v-col>
                                        <v-col  v-if="edit_page" id="suggestionsContainer">
                                            <div class="text-center">

                                                <v-combobox
                                                        append-icon=""
                                                        style="z-index: 1000;margin-top:-10px;text-align: center !important;"
                                                        class="text-center hide_my_spin"
                                                        id="hide_combo"
                                                        v-model="style.suggestions"
                                                        :items="style.suggestions"
                                                        type="number"
                                                        :disabled="need_setup"

                                                        single-line
                                                        attach="suggestionsContainer"
                                                        :delimiters=delimiters

                                                        multiple
                                                        small-chips
                                                >
                                                    <template v-slot:item='{item}'> <v-chip  small label class="ma-2" :color=colorChip(item) text-color="white" > <b>{{item}}</b></v-chip></template>
                                                    <template v-slot:selection='{item}'> <v-chip @click="removeSuggestion(item)" small label class="ma-2"  :color=colorChip(item) text-color="white" > <b>{{item}}</b></v-chip></template>

                                                </v-combobox>
                                            </div>
                                        </v-col>
                                    </v-row>



                                    <v-checkbox
                                        :disabled="!mediashare.enabled"
                                        class="mx-auto"
                                        dense v-model="video_message"
                                        color="success"
                                        style="margin-bottom:-20px;margin-left:-4px !important;margin-top:-4px;"



                                    >
                                      <v-tooltip bottom slot="label">
                                        <template v-slot:activator="{ on, attrs }">


                                            <p style="margin-bottom:0px;" v-bind="attrs"
                                            v-on="on" >Lägg till video
                                            </p>
                                          <v-chip to="/video_alert" label v-if="!mediashare.enabled && page_editable && !video_message" style="margin-left:4px;pointer-events:all;" tile dark color="green" small>Aktivera</v-chip>
                                          <v-chip v-else-if="!video_message" style="margin-left:4px;" dark color="green" small>Nyhet!</v-chip>


                                        </template>
                                        <span>Inkludera ett videoklipp som spelas upp i streamen</span>
                                      </v-tooltip>

                                    </v-checkbox>



                                  <v-row style="">
                                        <v-col
                                        >
                                          <v-tabs-items :dark="style.SUGGESTION_TWO || in_bcf"
                                                        v-model="video_message_tab">
                                            <v-tab-item
                                            >
                                              <v-textarea
                                                  dense
                                                  no-resize
                                                  outlined
                                                  :counter=249
                                                  label="Meddelande"
                                                  :rules="rules.message"
                                                  :value="message"
                                                  rows="5"
                                                  :disabled="need_setup"

                                                  v-model="message"
                                                  class="no_scroll"
                                              ></v-textarea>
                                            </v-tab-item>
                                            <v-tab-item>


                                              <v-text-field
                                                  append-icon="mdi-youtube"
                                                  dense
                                                  style="margin-top:8px;"
                                                  label="Youtube-länk"
                                                  outlined
                                                  v-model="youtube_link"

                                              ></v-text-field>
                                              <v-card :disabled="youtube_loading" flat outlined :loading="youtube_loading?'green':false" style="height:150px;width:100%;">

                                                <v-row style="width:100%;">
                                                  <v-col cols="4">
                                                    <v-img
                                                        style="height:145px;width:145px;border-radius: 4px; margin-top: -12px;"
                                                        :src="youtube_video.image"
                                                    >

                                                    </v-img>
                                                  </v-col>
                                                  <v-col cols="8" >
                                                    <span v-if="youtube_video.title!=='' && youtube_video.views<mediashare.view_limit">
                                                      <v-card-title class="text-truncate d-inline-block" style="font-size:18px;display:block;width:100%;text-align: center;color:red;"><i>Fel</i></v-card-title>
                                                      <v-card-subtitle style="width:100%;text-align: center;">Klippet har för låg rating för att spelas upp</v-card-subtitle>
                                                    </span>
                                                    <span v-else-if="youtube_video.title!==''">
                                                      <v-card-title class="text-truncate d-inline-block" style="font-size:18px;display:block;width:100%;text-align: center;"><i>{{youtube_video.title}}</i></v-card-title>
                                                      <v-card-subtitle style="width:100%;text-align: center;"><b style="">{{Math.floor(((amount_selected?amount_selected:0)/mediashare.price))}} sekunder</b> * {{mediashare.price}} kr/sekund = {{amount_selected?amount_selected:0}} kr</v-card-subtitle>
                                                    </span>

                                                    <span v-else-if="youtube_video.title===''">
                                                      <v-card-title class="text-truncate d-inline-block" style="font-size:18px;display:block;width:100%;text-align: center;"><i>Klistra in Youtube-länk</i></v-card-title>
                                                      <v-card-subtitle style="width:100%;text-align: center;"><b style=""> {{mediashare.price}} kr/sekund</b></v-card-subtitle>
                                                    </span>

                                                  </v-col>
                                                </v-row>
                                              </v-card>


                                            </v-tab-item>
                                          </v-tabs-items>

                                        </v-col>


                                    </v-row>
                                  <v-row  v-show="video_message_tab===1" style="margin-top:-4px;">
                                    <v-col cols="4">
                                      <v-text-field
                                          dense
                                          label="Börja vid"
                                          outlined
                                          suffix="s"
                                          v-model="start_at"
                                          type="number"
                                          class="hide_my_spin"

                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="8">
                                      <v-checkbox
                                          v-model="sound_only"
                                          color="success"
                                          label="Spela endast ljud"
                                          style="margin-bottom:-20px;margin-left:-4px !important;margin-top:2px;"

                                      >


                                      </v-checkbox>

                                    </v-col>

                                  </v-row>

                                    <v-row style="margin-top:-20px;">
                                        <v-col cols="12">
                                            <v-text-field
                                                    dense
                                                    label="Ditt telefonnummer"
                                                    outlined
                                                    :rules="rules.number"
                                                    v-model="phone_number"
                                                    :disabled="need_setup"
                                                    type="number"
                                                    class="hide_my_spin"

                                            ></v-text-field>
                                        </v-col>

                                    </v-row>




                                    <v-row style="margin-top:-40px;margin-bottom:-30px;" justify="center">

                                        <v-col  cols="10">

                                            <v-checkbox  :style="{'width':in_bcf?'500px':'200px'}"
                                                         :disabled="need_setup"
                                                         class="mx-auto" dense v-model="accept_terms" color="success"

                                            >
                                              <small v-if="!in_bcf" slot="label" >Jag godkänner <a href="/villkor" target="_blank" @click.stop style="z-index: 10;">köpvillkoren</a></small>
                                              <small v-else slot="label" >Jag godkänner <a href="/villkor" target="_blank" @click.stop style="z-index: 10;">köpvillkoren</a> och Barncancerfondens <a href="https://www.barncancerfonden.se/villkor-integritetspolicy-och-cookies/" target="_blank" @click.stop style="z-index: 10;">GPDR-policy</a> </small>

                                            </v-checkbox>


                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn class="mx-auto"  @click="pay" v-if="ready_to_pay" color="success">Betala {{amount_selected}} KR</v-btn>
                                <v-btn class="mx-auto" v-else disabled color="success">Betala</v-btn>

                            </v-card-actions>
                            <v-img v-if="style.SUGGESTION_TWO" style="position:absolute;left:15px;bottom:10px;" height="40" width="90" contain :src="require('../assets/swish_dark_bg.png')"></v-img>
                            <v-img v-if="!style.SUGGESTION_TWO" style="position:absolute;left:15px;bottom:10px;" height="40" width="90" contain :src="require('../assets/swish_light_bg.png')"></v-img>

                        </v-card>
                    </v-col>
            <v-col align="right" :cols="$vuetify.breakpoint.mdAndUp? 3 : $vuetify.breakpoint.smAndDown? '0':'1'">
            </v-col>
        </v-row>
            </v-tab-item>
            <v-tab-item style="height:100%;overflow-y: visible !important;">
                <v-row style="top:125px;position:relative;" align="center">
                    <v-col :cols="$vuetify.breakpoint.mdAndUp? 2 : 0">

                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mdAndUp? 8 : 12">
                        <v-card
                                class="mx-auto px-2"
                                max-width="744"
                                style="margin-bottom:200px;"
                                :dark="style.SUGGESTION_TWO"


                        >
                            <div style="width:100%;height:160px;display:flex;position:absolute;top:-70px;left:0;z-index: 4;pointer-events: none;">
                                <v-img contain style="height:150px;" :src="require('../assets/sh_logo2.png')"></v-img>

                            </div>







                            <v-card-text>

                                <v-form ref="payment_form" >


                                    <v-row>

                                        <v-col cols="12" class="force_height" style="height:400px;">

                                            <v-tabs-items v-model="collection_select" style="height:100%;">
                                                <v-img
                                                        :src="require('../assets/explore_the_city.png')"
                                                        style="position:absolute;width:100%;height:400px; border-top-left-radius:14px; border-top-right-radius:14px;"
                                                        eager
                                                >


                                                </v-img>
                                                <v-tab-item
                                                        v-for="(collection,index) in collections"
                                                        :key="index"
                                                        style="height:400px;"
                                                >
                                                    <v-row style="width:100%;height:100%;">
                                                        <v-col cols="8">
                                                            <v-card
                                                                    class="mx-auto"
                                                                    max-width="274"
                                                                    height="300"
                                                                    style="top:30px;"
                                                                    :dark="style.SUGGESTION_TWO"
                                                            >

                                                                <v-img
                                                                        contain

                                                                        height="200"
                                                                        :src='collection.IMAGE'
                                                                ></v-img>
                                                                <v-chip class="digi shadowed green" dark style="position:absolute;top:4px;right:4px;">{{collection.PRICE}} kr</v-chip>


                                                                <v-card-subtitle style="font-size:18px;" :dark="style.SUGGESTION_TWO" class="digi"><b>{{collection.NAME}}</b></v-card-subtitle>
                                                                <v-card-text style="font-size:12px;line-height: 14px;margin-bottom:0;padding-bottom:0;" class=" digi">
                                                                    {{collection.DESC}}
                                                                </v-card-text>



                                                                <v-card-actions style="position:absolute;bottom:0;left:0;width:100%;" >

                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-col>

                                                        <v-col cols="4">

                                                            <v-card
                                                                    class="mx-auto"
                                                                    max-width="274"

                                                                    style="top:70px;"
                                                                    :dark="style.SUGGESTION_TWO"
                                                            >
                                                                <v-card-text class="digi">
                                                                    Öppnas i Stream Hotel

                                                                    <v-chip
                                                                            class="green_grad ma-2 shadowed"
                                                                            text-color="white"

                                                                    >
                                                                        <span style="min-width:100px;">Common</span>
                                                                        <v-avatar
                                                                                right
                                                                                style="right:-8px;"
                                                                                class="green darken-4 pa-4 ml-0"
                                                                        >
                                                                           <span style="font-size:10px;text-shadow: none;">47%</span>
                                                                        </v-avatar>

                                                                    </v-chip>
                                                                    <v-chip
                                                                            class="blue_grad ma-2 shadowed"
                                                                            text-color="white"

                                                                    >
                                                                        <span style="min-width:100px;">Rare</span>
                                                                        <v-avatar
                                                                                right
                                                                                style="right:-8px;"
                                                                                class="blue darken-4 pa-4 ml-0"
                                                                        >
                                                                            <span style="font-size:10px;text-shadow: none; ">37%</span>
                                                                        </v-avatar>

                                                                    </v-chip>
                                                                    <v-chip
                                                                            class="purple_grad ma-2 shadowed"
                                                                            text-color="white"
                                                                    >
                                                                        <span style="min-width:100px;">Epic</span>
                                                                        <v-avatar
                                                                                right
                                                                                style="right:-8px;"
                                                                                class="purple darken-4 pa-4 ml-0"
                                                                        >
                                                                            <span style="font-size:10px;text-shadow: none;">15%</span>
                                                                        </v-avatar>

                                                                    </v-chip>
                                                                    <v-chip
                                                                            class="orange_grad ma-2 shadowed"
                                                                            text-color="white"
                                                                    >
                                                                        <span style="min-width:100px;">Legendary</span>
                                                                        <v-avatar
                                                                                right
                                                                                style="right:-8px;"
                                                                                class="orange  pa-4 ml-0"
                                                                        >
                                                                            <span style="font-size:10px;text-shadow: none;">1%</span>
                                                                        </v-avatar>

                                                                    </v-chip>

                                                                </v-card-text>
                                                            </v-card>

                                                        </v-col>

                                                    </v-row>


                                                </v-tab-item>
                                            </v-tabs-items>

                                        </v-col>
                                        <v-col cols="12">
                                            <v-tabs hide-slider color="black" v-model="collection_select" >
                                                <v-tab :style="{'background':collection_select===index?'rgba(0,0,0,0.15)':'transparent'}" class="digi shadowed"  v-for="(collection,index) in collections" :key="index"  >
                                                    <v-img
                                                            eager
                                                            contain
                                                            style="height:50px;position:absolute;z-index: -1;"
                                                            :src="collection.IMAGE"
                                                    ></v-img>
                                                </v-tab>
                                            </v-tabs>

                                        </v-col>
                                        <v-col cols="12" style="margin-top:-24px;height: 30px;">
                                            <v-btn
                                                    tile
                                                    small
                                                    color="green"
                                                    block
                                                    dark
                                                    @click="add_to_cart(collections[collection_select])"
                                                    class="digi shadowed"
                                                    v-if="(streamer_has_sh) && (streamer_sells_sh)"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                                Lägg i varukorg
                                            </v-btn>
                                            <v-btn
                                                    small
                                                    color="green"
                                                    block
                                                    class="digi"
                                                    v-else
                                                    disabled
                                                    :dark="style.SUGGESTION_TWO"

                                            >
                                                Ej tillgänglig
                                            </v-btn>

                                        </v-col>

                                    </v-row>
                                    <v-row style="min-height:200px;max-height:200px;">
                                        <v-col>

                                            <v-slide-x-transition>
                                            <v-card v-if="show_hicards_basket" flat style="">

                                                <v-card-text>
                                                    <v-row v-for="(order_row,index) in order" :key="index" style="height:20px;">
                                                        <v-col cols="8">
                                                            {{order_row.count}} x {{order_row.product.NAME}}
                                                        </v-col>
                                                        <v-col style="white-space: nowrap;" cols="3" align="right">
                                                            {{order_row.count * order_row.product.PRICE}} kr

                                                        </v-col>
                                                        <v-col cols="1">
                                                            <v-btn @click="removeFromBasket(order_row)" style="margin-top: -4px;" small icon><v-icon small>close</v-icon></v-btn>

                                                        </v-col>


                                                    </v-row>
                                                    <v-divider style="margin-top:10px;"></v-divider>
                                                    <v-row>
                                                        <v-col align="right" cols="11">
                                                            Att betala: {{cardCost}} kr inkl. moms

                                                        </v-col>
                                                        <v-col cols="1" >
                                                        </v-col>

                                                    </v-row>

                                                </v-card-text>



                                            </v-card>
                                            </v-slide-x-transition>
                                            <v-fade-transition>
                                                <v-card v-if="show_hicards_text" flat style="">

                                                    <v-card-text>
                                                        Stream Hotel är ett 3D-multiplayer-spel som spelas i en overlay på twitch.tv. Genom att spela Stream Hotel tjänar spelare guld som kan spenderas på bilar, hattar, kläder eller en ny dator! Spelare kan också köpa Chests för att stötta streamers. Chests innehåller föremål från Stream Hotel!

                                                        <a href="/streamhotel">Läs mer</a>
                                                    </v-card-text>



                                                </v-card>
                                            </v-fade-transition>
                                        </v-col>

                                    </v-row>

                                    <v-row align="center" justify="center">
                                        <v-col style="max-width:300px;margin-top:-40px;" cols="6">
                                            <v-combobox
                                                    :items="name_suggestions"
                                                    style="text-align: center;"
                                                    color="red"
                                                    v-model="recipient_name"
                                                    @input.native="recipient_name=$event.srcElement.value"
                                                    hide-no-data
                                                    auto-select-first
                                                    label="Mottagare"
                                                    outlined
                                                    dense
                                            >
                                                <template v-slot:item="data">
                                                    <v-chip
                                                            :key="JSON.stringify(data.item)"
                                                            v-bind="data.attrs"
                                                            :input-value="data.selected"
                                                            @click:close="data.parent.selectItem(data.item)"
                                                            class="digi"
                                                            link
                                                            dark
                                                            :color="get_color_from_name(data.item)"
                                                    >

                                                        {{ data.item }}
                                                    </v-chip>
                                                </template>

                                            </v-combobox>
                                        </v-col>
                                        <v-col style="max-width:300px;margin-top:-40px;" cols="6">
                                            <v-text-field
                                                    dense
                                                    label="Ditt telefonnummer"
                                                    outlined
                                                    :rules="rules.number"
                                                    v-model="phone_number"
                                                    :disabled="need_setup || collections.length===0"

                                                    type="number"
                                                    class="hide_my_spin"

                                            ></v-text-field>
                                        </v-col>

                                    </v-row>




                                    <v-row style="margin-top:-40px;margin-bottom:-30px;" justify="center">

                                        <v-col  cols="10">

                                            <v-checkbox  style="width:200px;"
                                                         :disabled="need_setup || collections.length===0"
                                                         class="mx-auto" dense v-model="accept_card_terms" color="success"

                                            ><small slot="label">Jag godkänner <a href="/villkor">köpvillkoren</a></small></v-checkbox>


                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn class="mx-auto"  @click="pay_hicards" v-if="ready_to_pay_hicards" color="success">Betala {{cardCost}} KR</v-btn>
                                <v-btn class="mx-auto" v-else disabled color="success">Betala</v-btn>

                            </v-card-actions>
                            <v-img v-if="style.SUGGESTION_TWO" style="position:absolute;left:15px;bottom:10px;" height="40" width="90" contain :src="require('../assets/swish_dark_bg.png')"></v-img>
                            <v-img v-if="!style.SUGGESTION_TWO" style="position:absolute;left:15px;bottom:10px;" height="40" width="90" contain :src="require('../assets/swish_light_bg.png')"></v-img>

                        </v-card>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mdAndUp? 2 : 0">
                    </v-col>
                </v-row>
            </v-tab-item>

        </v-tabs-items>


        <input id="headerInput" style="display:none;" type="file" accept="image/*"   v-on:change="openHeaderFile">

        <v-bottom-sheet style="position:relative;" :content-class="this.$vuetify.breakpoint.mdAndUp? 'to_the_left':''"  inset persistent overlay-opacity="0" :retain-focus=false v-model="edit_page">
            <v-sheet :dark="style.SUGGESTION_TWO"  tile class="text-center">

                <v-btn :dark="style.SUGGESTION_TWO"  @click="edit_page=false" class="ma-2"     style="top: -60px;z-index: 1000" tile>
                <v-icon left>mdi-content-save</v-icon> Spara
                </v-btn>
                <v-container class="mx-auto my-auto pa-auto" style="margin-top: -50px !important;">

                            <v-row class="px-4">
                                <v-col>
                                <v-text-field


                                        v-model="style.PATH"
                                        outlined
                                        label="URL"
                                        dense

                                        hide-details
                                        :prefix="this.$vuetify.breakpoint.mdAndUp? 'hihat.io/':''"
                                >
                                    <v-btn small v-clipboard:copy="'https://hihat.io/'+style.PATH"  slot="append" icon >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>



                                </v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                            hide-details
                                            :disabled="in_bcf"

                                            outlined
                                            dense
                                            label="Minsta donation"
                                            type="number"
                                            v-model="style.MIN_DONATION"
                                            class="hide_my_spin"
                                    >
                                        <v-btn disabled small slot="append" text >
                                            SEK
                                        </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>


                    <v-row align="center" justify="center" class="px-4">
                        <v-col align="center" class="ma-0 pa-0" cols="6">
                            <v-checkbox
                                    off-icon="mdi-eye-off"
                                    on-icon="mdi-eye"
                                    class="flex-center ma-0 pa-0"
                                    style="max-width:150px;"
                                    color="gray"
                                    :disabled="in_bcf"

                                    v-model="style.SUGGESTION_THREE"
                                    label="Leaderboard">
                            </v-checkbox>
                        </v-col>
                        <v-col align="center" class="ma-0 pa-0" cols="6">
                            <v-checkbox
                                    off-icon="mdi-white-balance-sunny"
                                    on-icon="mdi-weather-night"
                                    class="flex-center ma-0 pa-0"
                                    style="max-width:150px;"
                                    color="gray"
                                    v-model="style.SUGGESTION_TWO"
                                    :label="dark_mode_text">
                              :disabled="in_bcf"



                            </v-checkbox>


                        </v-col>

                    </v-row>

                    <v-row class="px-4">


                                <v-col cols="6" style="margin-top: -8px;">
                                    <v-menu
                                            v-model="menuStart"
                                            :close-on-content-click="false"
                                            :nudge-width="200"
                                            offset-x
                                            content-class="color_menu"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    style="z-index: 1000;text-shadow: 4px 4px 20px white;"
                                                    class="mx-2 my-2"
                                                    :color=style.START_COLOR
                                                    v-on="on"
                                                    :disabled="in_bcf"

                                                    block
                                            >Färg 1</v-btn>
                                        </template>
                                        <v-color-picker style="z-index: 1000;" @input="changeStart" :value=style.START_COLOR class="ma-2" hide-inputs></v-color-picker>
                                    </v-menu>
                                </v-col>
                        <v-col cols="6" style="margin-top: -8px;">



                                    <v-menu

                                            v-model="menuEnd"
                                            :close-on-content-click="false"
                                            :nudge-width="200"
                                            offset-x
                                            content-class="color_menu"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    :color=style.END_COLOR
                                                    block
                                                    style="z-index: 1;text-shadow: 4px 4px 20px white;"
                                                    :disabled="in_bcf"

                                                    class="mx-2 my-2"
                                                    v-on="on"
                                            >Färg 2</v-btn>
                                        </template>
                                        <v-color-picker  @input="changeEnd" :value=style.END_COLOR class="ma-2" hide-inputs></v-color-picker>
                                    </v-menu>

                                </v-col>

                            </v-row>





                </v-container>

            </v-sheet>
        </v-bottom-sheet>
        <SwishModalDonation :amount="amount_selected" :nickname="order_nickname"  :type="pay_for"  :pay_dialog_hihat="pay_dialog_hihat" v-on:donated="done_donate" v-on:hide="pay_dialog_hihat=false"></SwishModalDonation>
        <SwishModalPrivateDonation :amount="amount_selected" :nickname="order_nickname_private"  :type="'Donationen'"  :pay_dialog_private="pay_dialog_private" v-on:donated="done_donate" v-on:hide="pay_dialog_private=false"></SwishModalPrivateDonation>
        <PaymentStatus :show="payment_status" :result="payment_result"></PaymentStatus>
        <v-dialog
                v-model="need_setup"
                max-width="390"

        >
            <v-card style="padding-top: 20px;">
                <div style="text-align: center;width:100%;" class="headline">🚧 Under konstruktion 🚧</div>

                <v-card-text style="text-align: center;margin-top: 10px;">
                    Denna sida är inte helt färdig, kom gärna förbi senare!
                </v-card-text>
            </v-card>


        </v-dialog>
        <v-dialog
                v-model="prompt_setup"
                max-width="290"
                persistent
        >
            <v-card>
                <v-card-title class="headline">Det saknas uppgifter!</v-card-title>

                <v-card-text>
                    För att ta emot donationer via Swish behöver du åtgärda:
                </v-card-text>
                <v-list>
                    <v-list-item-group >
                        <v-list-item
                                v-if="!alerts_setup"
                                link
                                :to="'/alerts'"

                        >
                            <v-list-item-icon>
                                <v-icon>mdi-chat-alert</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Alerts</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                                link
                                :to="'/payments'"
                                v-if="!payments_setup"

                        >
                            <v-list-item-icon>
                                <v-icon>mdi-cash-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Utbetalningar</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>

                <v-card-actions>
                    <v-spacer></v-spacer>



                    <v-btn
                            color="green darken-1"
                            text
                            @click="prompt_setup = false"
                    >
                        Låt mig kika bara!
                    </v-btn>
                    <v-spacer></v-spacer>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <WebViewHandler></WebViewHandler>



    </v-container>

</template>

<script>
    import DonationLeaderboard from '../components/DonationLeaderboard'
    import BCFLeaderboard from '../components/BCFLeaderboard'

    import SwishModalDonation from '../components/SwishModalDonation'
    import SwishModalPrivateDonation from "../components/SwishModalPrivateDonation";
    import PaymentStatus from '../components/PaymentStatus'
    import WebViewHandler from "../components/WebViewHandler";

    export default {
        name: "MyPage",
        components:{SwishModalPrivateDonation, DonationLeaderboard,SwishModalDonation,PaymentStatus,WebViewHandler,BCFLeaderboard},
        data:function(){
            return{
              youtube_loading:false,
              video_selected:0,
              sound_only:false,
              start_at:0,
              youtube_link_check:null,
              youtube_link:"",
              youtube_video:{
                image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                title:"",
                views:0
              },
              video_message_tab:0,
              video_message:false,
              mediashare:{
                enabled:false,
                price:1,
                view_limit:0,
                examples:[
                ]
              },
              in_bcf:false,
                rules:{
                    name:[v => v.length > 2 || 'Ange avsändare'],
                    message:[v => v.length <= 249 || 'Max 250 bokstäver', v => v.length > 0 || 'Skriv ett meddelande'],
                    amount:[v => v >= this.style.MIN_DONATION|| `Lägsta donation är ${this.style.MIN_DONATION} kronor`],
                    number:[function(v){
                        let res=v.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
                        if(res===0){
                            return true
                        }
                        else{
                            return "Ange ditt telefonnummer"
                        }

                    }],
                } ,
                message: '',
                edit_title:false,
                edit_desc:false,
                title:"",
                desc:"",
                path:"",
                startColor:"#919191",
                endColor:"#4b038d",
                editStartC:false,
                menuStart:false,
                menuEnd:false,
                showImageMenu:false,
                save_style_timeout:null,
                type_selected:0,
                amount_selected:null,
                sheet:null,
                edit_page:false,
                delimiters:[' '],
                accept_terms:false,
                accept_card_terms:false,
                sender_name:"",
                phone_number:"",
                pay_dialog_hihat:false,
                pay_dialog_private:false,
                order_nickname:"",
                order_nickname_private:"",
                page_editable:false,
                style:null,
                newImage:null,
                doneFetching:false,
                renderIndex:0,
                streamer_image:null,
                prompt_setup:false,
                prompt_unfinished:false,
                tab:0,
                basket:[],
                collections:[],
                show_hicards_text:true,
                show_hicards_basket:false,
                pay_for:"Donationen",
                streamer_sells_sh:false,
                streamer_has_sh:false,
                collection_select:0,
                name_suggestions:[],
                recipient_name:""





            }
        },
        methods:{
          get_overlay_info:function(){
            let http = new XMLHttpRequest();
            let pathname = window.location.pathname.substring(1);
            let url = '/api/overlay_info?path='+pathname;
            http.open('GET', url, true);
            let self=this;
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 200){
                let resp=JSON.parse(http.responseText);
                self.mediashare.enabled=resp.ENABLED===1;
                if(self.mediashare.enabled){
                  let setup=JSON.parse(resp.SETUP)
                  self.mediashare.examples=setup.examples;
                  self.mediashare.price=setup.price_per_second;
                  self.mediashare.view_limit=[0,1000,50000,0][setup.number_of_views];
                }else{
                  self.mediashare.examples=[]
                  self.mediashare.price=1;
                  self.mediashare.view_limit=0;
                }



              }

            };
            http.send();
          },

            get_youtube_info:function(){

              var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
              var match = this.youtube_link.match(regExp);
              let youtube_id=null;
              if (match && match[2].length === 11) {
                youtube_id=match[2];
              }
              if(youtube_id!==null){
                let http = new XMLHttpRequest();
                let url = '/api/video_info?video_id='+youtube_id;
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                  if(http.readyState === 4 && http.status === 200){
                    self.youtube_loading=false;
                    let video_info=JSON.parse(http.response);
                    if("error" in video_info){
                      self.youtube_video={
                        image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                        title:"",
                        views:0
                      }
                    }
                    else if(video_info.items.length===0){
                      self.youtube_video={
                        image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                        title:"",
                        views:0
                      }
                    }else{
                      self.youtube_video={
                        image:video_info.items[0].snippet.thumbnails.medium.url,
                        title:video_info.items[0].snippet.title,
                        views:video_info.items[0].statistics.viewCount

                      }
                    }
                  }
                };
                http.send();
              }


            },

            get_name_suggestions:function(){

                let http = new XMLHttpRequest();
                let url = 'https://hihat.io/api/name_like?name='+this.recipient_name;
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 200){
                        if(http.responseText==="[]"){
                            self.name_suggestions=[];
                        }else{
                            let names=JSON.parse(http.response);
                            self.name_suggestions=[];
                            for(let i=0;i<names.length;i++){
                                self.name_suggestions.push(names[i].NAME);
                            }
                        }
                    }
                };
                http.send();
            },
            get_color_from_name:function(name_in){
                let name=name_in.toLowerCase();
                let hash = 0;
                for (let i = 0; i < name.length; i++) {
                    hash = name.charCodeAt(i) + ((hash << 5) - hash);
                }
                var colour = '#';
                for (let i = 0; i < 3; i++) {
                    let value = (hash >> (i * 8)) & 0xFF;
                    colour += ('00' + value.toString(16)).substr(-2);
                }
                return colour;

            },
            removeFromBasket:function(order_to_remove){
              let keep=[];
              for(let i=0;i<this.basket.length;i++){
                  if(this.basket[i].UID!==order_to_remove.product.UID){
                      keep.push(this.basket[i]);
                  }
              }
              this.basket=keep;
            },
            add_to_cart:function(chest){
                this.basket.push(chest)
            },
             get_collections:function() {
                 let http = new XMLHttpRequest();
                 http.withCredentials = true;

                 let pathname = window.location.pathname.substring(1);

                 let url = '/api/get_streamhotel_packs?path=' + pathname;
                 http.open('GET', url, true);
                 let self=this;
                 http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                 http.onreadystatechange = function () {//Call a function when the state changes.


                     if (http.readyState === 4 && http.status === 200) {
                         if (http.response !== "no data") {

                             let respObj = JSON.parse(http.response);
                             console.log(respObj);

                             self.collections=respObj.stream_hotel_setup.chests;
                             self.streamer_has_sh=respObj.stream_hotel_setup.streamer_active
                             self.streamer_sells_sh=respObj.streamer_setup.ACTIVE===1

                         }


                     }

                 };
                 http.send();
             },

            done_donate:function(){
                this.pay_dialog_hihat=false;
                this.pay_dialog_private=false;


                this.phone_number="";
                this.sender_name="";
                this.amount_selected=null;
                this.accept_terms=false;
                this.message="";
                this.renderIndex++;
                this.recipient_name="";
                this.$refs.payment_form.resetValidation();



            },
            pay_hicards:function(){

                if((typeof this.$store.state.STREAMER.SID)!=="number"){
                    this.$store.state.APP.SHOW_LOGIN=true;
                }
                else{

                    this.order[0]["totalcost"]=this.cardCost;
                    this.order[0]["sender_number"]=this.phone_number;
                    this.order[0]["streamername"]=window.location.pathname.substring(1);
                    this.order[0]["recipient"]=this.recipient_name;
                    this.amount_selected=this.cardCost;
                    let http = new XMLHttpRequest();
                    http.withCredentials = true;
                    let self=this;
                    let url = '/api/purchase_cards?';
                    http.open('POST', url, true);
                    http.setRequestHeader('Content-type', 'application/json');
                    http.onreadystatechange = function() {
                        if(http.readyState === 4) {
                            if(http.status===200){
                                let data = JSON.parse(http.response);
                                self.pay_for="Köpet";

                                self.pay_dialog_hihat=true;
                                self.order_nickname=data["nickname"]

                            }
                            else{
                                self.$store.commit("update_snackbar","Ett fel inträffade");

                            }
                        }
                    };

                    http.send(JSON.stringify(this.order));
                }
            },
            pay:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/purchase_donation?';
                let pathname=window.location.pathname.substring(1);
                if(lengthInUtf8Bytes(this.message)>255){
                    this.message=this.message.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a').replace(/Ä/g, 'A').replace(/Ö/g, 'O').replace(/Å/g, 'A');
                }

                this.sender_name=this.sender_name.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a').replace(/Ä/g, 'A').replace(/Ö/g, 'O').replace(/Å/g, 'A').replace(/[\W_]+/g, '');

                this.message=this.message.replace(/{/g, '');

                let self=this;
                let params="";
                if(this.video_message){
                  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                  var match = this.youtube_link.match(regExp);
                  let youtube_id=null;
                  if (match && match[2].length === 11) {
                    youtube_id=match[2];
                  }
                  let opacity=this.sound_only?0:100
                  let duration=Math.floor(this.amount_selected/this.mediashare.price);
                  let video_info={
                    id:youtube_id,
                    start_at:this.start_at,
                    opacity:opacity,
                    sender:this.sender_name,
                    amount:this.amount_selected,
                    volume:100,
                    duration:duration

                  }
                  video_info=JSON.stringify(video_info);
                  params = 'PATH='+pathname+'&senderName='+this.sender_name+'&amount='+parseInt(this.amount_selected)+'&message='+video_info+'&number='+this.phone_number+'&type=message';

                }else{
                  params = 'PATH='+pathname+'&senderName='+this.sender_name+'&amount='+parseInt(this.amount_selected)+'&message='+this.message+'&number='+this.phone_number+'&type=message';

                }
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 412) {
                        self.$store.commit("update_snackbar","Vänta ett tag innan du startar en ny donation");

                    }
                    else if(http.readyState === 4 && http.status === 413) {
                        self.$store.commit("update_snackbar","Ett fel inträffade");
                    }
                    else if(http.readyState === 4 && http.status === 405) {
                      self.$store.commit("update_snackbar","Telefonnumret är avstängt från Hihat");
                    }

                    else if(http.readyState === 4 && http.status !== 200) {
                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        self.pay_for="Donationen";

                        if(data["isBank"] || data["isFee"]){
                            self.pay_dialog_hihat=true;
                            self.order_nickname=data["nickname"]

                        }

                        else{
                            self.pay_dialog_private=true;
                            self.order_nickname_private=data["nickname"]
                        }
                    }

                    };
                if(params===""){
                  self.$store.commit("update_snackbar","Ett fel inträffade");
                }else{
                  http.send(params);
                }




            },

            save_style(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/styles?';
                let header="nvm";
                if(this.newImage===null){
                    header="nvm";
                }
                if(this.style.IMAGE===false){
                    header="none"
                }
                else if(this.newImage!==null){
                    header=this.newImage.replace('url(','').replace(')','').replace(/"/gi, "")
                }
                let suggestions=JSON.stringify(this.style.suggestions);
                let dark_mode= this.style.SUGGESTION_TWO ? 1 : 0;
                let show_leaderboard= this.style.SUGGESTION_THREE ? 1 : 0;
                this.style.PATH=this.style.PATH.replace(/\W/g, '')
                this.style.PATH=this.style.PATH.replace(' ', '');

                let params ='PATH='+this.style.PATH+'&MIN_DONATION='+this.style.MIN_DONATION+'&TITLE='+this.style.TITLE+'&SUGGESTION_ONE='+suggestions+'&SUGGESTION_TWO='+dark_mode+'&SUGGESTION_THREE='+show_leaderboard+'&START_COLOR='+this.style.START_COLOR+'&END_COLOR='+this.style.END_COLOR+'&DESC='+this.style.DESC+'&IMAGE='+header;

                //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');


                http.send(params);
            },
            removeSuggestion(amount){
                this.style.suggestions.splice(this.style.suggestions.indexOf(amount), 1);
            },
            colorChip(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#606060"
                }
            },
            changeStart(e){
                this.style.START_COLOR=e;
            },
            changeEnd(e){
                this.style.END_COLOR=e;

            },
            openHeaderFile:function(file) {

                let input = file.target;


                let reader = new FileReader();
                let self=this;
                reader.onload = function(){
                    self.newImage=reader.result;
                    self.style.IMAGE=true;
                };
                reader.readAsDataURL(input.files[0]);
            },
            updateHeaderImage:function(){
                document.getElementById("headerInput").click();
            },
            removeHeaderImage:function(){
                this.style.IMAGE=false;
            },
            getStyleData(){
                this.doneFetching=false;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/getStyles?';
                let pathname=window.location.pathname.substring(1);
                let params = 'PATH='+pathname;
                http.open('POST', url, true);
                let index=pathname.indexOf("?");
                if(index>0){
                    pathname=pathname.substr(0,index);
                }
                let self=this;
                document.title=pathname;
                this.path=pathname;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.

                    if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        if(data["redirect"]){
                          //self.$router.push('/404')
                          self.$router.replace(data["redirect"])
                        }
                        else if(data["error"]){
                            //self.$router.push('/404')
                            self.$router.replace("/404")
                        }
                        else{
                            if(data["MY_PAGE"]){
                                self.page_editable=true;
                                if(!self.alerts_setup || !self.payments_setup){
                                    self.prompt_setup=true;
                                }
                            }
                            else{
                                if(!self.alerts_setup || !self.payments_setup){
                                    self.prompt_unfinished=true;
                                }
                            }
                            try{
                                data.suggestions=JSON.parse(data.SUGGESTION_ONE);
                                if(typeof data.suggestions !== "object"){
                                    data.suggestions=[39,59,99]
                                }
                            }
                            catch{
                                data.suggestions=[39,59,99]
                            }
                            if(data["SUGGESTION_TWO"]===1){
                                data["SUGGESTION_TWO"]=true;
                            }
                            else{
                                data["SUGGESTION_TWO"]=false
                            }
                            if(data["SUGGESTION_THREE"]===0){
                                data["SUGGESTION_THREE"]=false;
                            }
                            else{
                                data["SUGGESTION_THREE"]=true
                            }
                            self.style=data;

                            self.set_streamer_image();
                        }

                    }

                };
                http.send(params);
    },
            set_streamer_image(){
                var image = new Image();
                let self=this;
                image.onload = function() {
                    self.streamer_image=image.src
                    self.doneFetching=true;

                };
                image.onerror = function() {

                    self.streamer_image=`/api/avatar/${self.style.USER_NAME.toLowerCase()}`;
                    self.doneFetching=true;

                };

                image.src = "/api/images/users/"+this.style.SID+".png";
            },
          get_bcf_status:function(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let self=this;
            let url = '/api/in_bcf?path='+window.location.pathname.substring(1);
            http.open('GET', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            http.onreadystatechange = function() {//Call a function when the state changes.


              if(http.readyState === 4 && http.status === 200){
                let resp=JSON.parse(http.responseText);
                if(resp["in_bcf"]){
                  self.in_bcf=true;
                }else{
                  self.in_bcf=false;

                }




              }

            };
            http.send();
          }


        },
        mounted:function(){
            this.getStyleData();
            this.get_collections();
            if(this.$route.query.f==="sh"){
                this.tab=1;
            }
            this.get_bcf_status();
            this.get_overlay_info();






        },
        computed:{
            cardCost:function(){
              let total=0;

              for(let i=0;i<this.order.length;i++){
                  total+=this.order[i].count*this.order[i].product.PRICE;
              }
              return total
            },
            order:function(){
              let toReturn={};
              for(let i=0;i<this.basket.length;i++){
                  if(toReturn[this.basket[i].UID]===undefined || toReturn[this.basket[i].UID]===null){
                      toReturn[this.basket[i].UID]={
                          count:0,
                          product:this.basket[i]
                      }
                  }
                  toReturn[this.basket[i].UID].count+=1;

              }
              return Object.values(toReturn);


            },

            payments_setup:function(){

                if((this.$store.state.STREAMER.PAYMENT_TYPE==="SWISH" || this.$store.state.STREAMER.PAYMENT_TYPE==="BANK2") && this.$store.state.STREAMER.PHONE_NUMBER.length>6){
                    return true
                }
                else if(this.$store.state.STREAMER.PAYMENT_TYPE==="BANK" && this.$store.state.STREAMER.BANKACCOUNT.length>6 && this.$store.state.STREAMER.PERSONAL_NUMBER.length>6){
                    return true
                }
                else{
                    return false
                }

            },
            need_setup:function(){
                if(this.style.IS_SETUP===1){
                    return false
                }
                else if(this.style.IS_SETUP===0){
                    return true
                }
                else{
                    return false
                }
            },
            alerts_setup:function(){
              return (this.$store.state.STREAMER.STREAMELEMENTS || this.$store.state.STREAMER.STREAMLABS || this.$store.state.STREAMER.HIHAT)
            },
            dark_mode_text:function(){
                if(this.style.SUGGESTION_TWO){
                    return "Mörkt tema"
                }
                else{
                    return "Ljust tema"

                }
            },

            ready_to_pay:function(){
                    if(parseInt(this.amount_selected)>=parseInt(this.style.MIN_DONATION) && this.accept_terms && this.sender_name.length>2 && this.message.length<250 ){
                        let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
                        if(res===0){
                          if(this.video_message){
                            if(this.youtube_video.views>this.mediashare.view_limit){
                              return true
                            }else{
                              return false
                            }
                          }else{
                            return true
                          }
                        }
                        else{
                            return false
                        }
                    }
                    else{
                        return false
                    }
            },
            ready_to_pay_hicards:function(){
                if(this.basket.length>0 && this.accept_card_terms && this.recipient_name.length>2){
                    let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
                    if(res===0){
                        return true
                    }
                    else{
                        return false
                    }
                }
                else{
                    return false
                }
            },
            payment_status:function(){
                if(this.$route.query.result===undefined){
                    return false;
                }
                else{
                    return true;
                }

            },
            payment_result:function(){
                if(this.$route.query.result===undefined){
                    return ""
                }
                else{
                    return this.$route.query.result
                }
            }

        },
        watch:{

          edit_page:function(){
            if(this.edit_page){
              this.video_message=false;
            }
          },

          video_selected:function(){
            if(this.video_selected!==0){
              this.youtube_link=this.mediashare.examples[this.video_selected-1].link;
              this.start_at=this.mediashare.examples[this.video_selected-1].start_at;
              this.sound_only=this.mediashare.examples[this.video_selected-1].sound_only;


            }else{
              this.youtube_video={
                image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                title:"",
                views:0
              }
              this.start_at=0;
              this.sound_only=false;
            }
          },

          youtube_link:function(){
            if(this.youtube_link!==""){
              this.youtube_loading=true;
            }else{
              this.video_selected=0;
              this.youtube_video={
                image:"https://i.ytimg.com/vi/unknown/hqdefault.jpg",
                title:"",
                views:0
              }
            }
            clearTimeout(this.youtube_link_check);
            let self=this;
            this.youtube_link_check=setTimeout(function(){
              self.get_youtube_info();
            },500);
          },

          video_message:function(){
            this.video_message_tab=this.video_message?1:0
          },
            recipient_name:function(){
                if(this.recipient_name!==""){
                    this.get_name_suggestions();
                }else{
                    this.name_suggestions=[];
                }
            },
            '$route': function () {
              this.getStyleData();
              this.get_collections();
              if(this.$route.query.f==="sh"){
                this.tab=1;
              }
              this.get_bcf_status();
            },
            tab: function (newVal) {
                if(newVal===0){
                    window.history.replaceState(null, null, window.location.pathname);
                }
                else{
                    window.history.replaceState(null, null, window.location.pathname+"?f=sh");

                }
            },

            style:{ handler() {
                    if(this.doneFetching && this.page_editable){
                        clearTimeout(this.save_style_timeout);
                        let self=this;
                        this.save_style_timeout=setTimeout(function(){
                            self.save_style();
                        },1500);
                    }

                },deep: true},
            newImage:function(){
                if(this.doneFetching && this.page_editable){
                    clearTimeout(this.save_style_timeout);
                    let self=this;
                    this.save_style_timeout=setTimeout(function(){
                        self.save_style();
                    },1500);
                }

            },
            "basket.length":function(newVal,oldVal){
                let self=this;
                if(oldVal===0){
                    this.show_hicards_text=false;
                    this.show_hicards_basket=false;
                    setTimeout(function(){
                        self.show_hicards_basket=true;
                    },200)

                }
                else if(newVal===0){
                    this.show_hicards_text=false;
                    this.show_hicards_basket=false;
                    setTimeout(function(){
                        self.show_hicards_text=true;
                    },200)

                }
            }



        }
    }
    function lengthInUtf8Bytes(str) {
        let m = encodeURIComponent(str).match(/%[89ABab]/g);
        return str.length + (m ? m.length : 0);
    }


</script>

<style >

     .force_height .v-window__container{
        height:400px;
    }

    .shadowed{
        color: rgb(255 255 255);
        text-shadow: 2px 2px 2px #b8b8b8;
    }
    .green_grad{
        background: linear-gradient(0deg, rgba(9,108,7,1) 0%, rgba(32,142,39,1) 35%, rgba(16,218,5,1) 100%) !important;
    }

    .blue_grad{
        background: linear-gradient(0deg, rgba(8,46,180,1) 0%, rgba(41,62,213,1) 35%, rgba(0,138,255,1) 100%) !important;
    }

    .purple_grad{
        background: linear-gradient(0deg, rgba(88,8,180,1) 0%, rgba(150,41,213,1) 35%, rgba(154,0,255,1) 100%) !important;
    }

    .orange_grad{
        background: linear-gradient(0deg, rgba(180,106,8,1) 0%, rgba(213,145,41,1) 35%, rgba(255,196,0,1) 100%) !important;
    }
    .digi{
        font-family: 'Galindo', cursive;
        font-weight:500;

    }

    .faded_img{
        filter:saturate(0) brightness(300%);
    }

    .put_me_down > .v-input__control {
        margin-top: 7px!important;
    }
    .hover-darken:hover{
        background:rgba(0,0,0,0.1);
    }

    .display-1 > * input{
        max-height:40px !important;
    }

    .no_elevate{
        box-shadow:none;
    }

    .no_scroll > * textarea{
        overflow:hidden;
    }

    .to_the_left{
        position: relative;
        left:-34px;
    }

    .flex-center > * .v-input__slot {
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 10px;

    }

    .color_menu{
        min-width: 0 !important;
    }

    .color_menu > div{
        margin:0 !important;
    }

    .v-tabs-bar{
        background: transparent !important;
    }




</style>
